import { TranslationContextProvider } from 'schummar-translate/react';
import ButtonPrimary from '../basePageComponents/buttons/ButtonPrimary';
import './WelcomeDetails.css';
import t from '../translations/translate.ts';
import TextField from '../fields/TextField.js';
import TextFieldType from '../enums/TextFieldTypes.js';
import { useState } from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';

import checkbox_check from '../images/checkbox/checkbox_check.svg';
import checkbox_uncheck from '../images/checkbox/checkbox_uncheck.svg';
import LangNewSwitch from '../LangNewSwitch.js';
import { ifRightToLeft } from '../utils/ifLangDir.js';
import { useLocale } from '../LocaleContext';

export default function WelcomeDetails(
    { familyInviteToken, familyInfo,
        setFirstName, firstName, setLastName, lastName, setPhoneNumber, phoneNumber,
        phoneCode, setPhoneCode, letsGo
    }
) {
    const { locale } = useLocale();
    const [checkboxChecked, setCheckboxChecked] = useState(true);
    const [switchOpen, setSwitchOpen] = useState(false);
    //
    if (firstName.length >= 80) {
        setFirstName(firstName.substr(0, 79));
        NotificationManager.warning("Text input", "First name length should be less than 80 symbols");
    }
    if (lastName.length >= 80) {
        setLastName(lastName.substr(0, 79));
        NotificationManager.warning("Text input", "Last name length should be less than 80 symbols");
    }
    //
    return <TranslationContextProvider locale={locale}>
        <div
            style={{
            direction: ifRightToLeft() ? 'rtl' : 'ltr',
        }}
         className="base_background WelcomeDetails_root">
            
            <div className="WelcomeDetails_title _black_28 no_select">
                <table style={{width: '100%'}} border={0}><tbody><tr>
                    <td>Details</td>
                    <td className='_black_bold' style={{width: 40}}>
                        <div onClick={()=>setSwitchOpen(true)} style={{backgroundColor: '#0B7F6C', 
                            fontSize: '14px',
                            textAlign: 'center',
                            textTransform: 'uppercase',
                            paddingTop: 12,
                            color: '#FFF', width: 40, height: 28, borderRadius: 20}}>
                        {localStorage.getItem('locale') == 'iw'? 'HE':localStorage.getItem('locale')}
                        </div>
                    </td>
                </tr></tbody></table>
            </div>

            <div className="WelcomeDetails_form no_select">
                <div className='_grey_16' style={{ marginBottom: 8 }}>
                    {t('nameInTxt')}
                </div>
                <TextField value={firstName} onChange={(e) => setFirstName(e.target.value)} type={TextFieldType.TEXT} />
                <div className='_grey_16' style={{ marginBottom: 8 }}>
                    {t('nameInTxt2')}
                </div>
                <TextField value={lastName} onChange={(e) => setLastName(e.target.value)} type={TextFieldType.TEXT} />
                <div style={{ height: 24 }} />
                <div className='_grey_16' style={{ marginBottom: 8 }}>
                    {t('phoneInTxt')}
                </div>
                <TextField
                    codeValue={phoneCode}
                    onCodeChange={(e) => { setPhoneCode(e.target.value) }}
                    value={phoneNumber}
                    onChange={(e) => { setPhoneNumber(e.target.value) }}
                    type={TextFieldType.PHONE} />
                <br />


                <table

                    onClick={() => setCheckboxChecked(!checkboxChecked)}
                    border={0}
                    style={{ lineHeight: '27px' }}
                >
                    <tbody>
                        <tr>
                            <td style={{ verticalAlign: 'top' }}>
                                <div style={{ height: 2 }} />
                                <img
                                    style={{ verticalAlign: 'top' }}
                                    src={checkboxChecked ? checkbox_check : checkbox_uncheck}
                                    alt={checkboxChecked ? 'checkbox+' : 'checkbox-'}
                                />
                            </td>
                            <td>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                            </td>
                            <td>
                                {t('iHaveReadWelcome_1')}
                                &nbsp;<a
                                    onClick={() => setCheckboxChecked(!checkboxChecked)}
                                    target='_blank' href={'/docs/' + localStorage.getItem('locale') + '/TERMS.html'}>{t('regConditions_url_0')}</a>&nbsp;
                                {t('iHaveReadWelcome_2')}
                                &nbsp;<a
                                    onClick={() => setCheckboxChecked(!checkboxChecked)}
                                    target='_blank' href={'/docs/' + localStorage.getItem('locale') + '/PRIVACY.html'}>{t('regConditions_url_1')}</a>&nbsp;
                                {t('iHaveReadWelcome_3')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br /><br /><br /><br /><br /><br /><br /><br />
        </div>
        <div className="WelcomeFooter base_background">
            <ButtonPrimary
            disable={checkboxChecked}
            onClick={() => {
                if (!checkboxChecked) {
                    letsGo();
                } else {
                    NotificationManager.warning("Please read and agree to the Terms of Use and Privacy Policy");
                }
            }
            } width='calc(100% - 15px)' txt={t('letsStart')}
            />
        </div>
        <NotificationContainer />
        <LangNewSwitch close={()=>setSwitchOpen(false)} isOpen={switchOpen}/>
    </TranslationContextProvider>;
}
// "Let's get started on the tasks!" 